import { render, staticRenderFns } from "./massReducedModal.vue?vue&type=template&id=27112da4&scoped=true&"
import script from "./massReducedModal.vue?vue&type=script&lang=js&"
export * from "./massReducedModal.vue?vue&type=script&lang=js&"
import style0 from "./massReducedModal.vue?vue&type=style&index=0&id=27112da4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27112da4",
  null
  
)

export default component.exports